import React from 'react'
import Slider from 'react-slick'

const SkippableBanner = () => {
  const imageArray = [
    {
      /* eslint-disable indent */
      url:
        'https://qaui.cltp.co/offermgmt/images/slider2.png'
    },
    {
      /* eslint-disable indent */
      url:
        'https://qaui.cltp.co/offermgmt/images/slider3.png'
    }
  ]
  return (
    <>
      <div
        className="bg-orange-100 login-banner"
        style={{
            width: 'calc(100% )',
            maxWidth: '410px',
            height: '437px',
            paddingTop: '58px'
          }}
      >
        <Slider
          dots={true}
          infinite={true}
          speed={500}
          slidesToShow={1}
          initialSlide={0}
          slidesToScroll={1}
          arrows={false}
          autoplay={true}
          appendDots={dots => <ul>{dots}</ul>}
          customPaging={i => <div className="ft-slick__dots--custom" />}
        >
          {imageArray?.map(item => (
            <div className="flex">
              <div>
                <div className="centered w-100vw  slider-banner-image" />
                <img width="100%" alt="home login banner" src={item?.url} />
              </div>
            </div>
            ))}
        </Slider>
      </div>
    </>
  )
}

export default SkippableBanner
